module.exports = __webpack_public_path__ + "img/mark-charge.2397fc9e.png";